<script setup>
import { useDisplay, useTheme } from 'vuetify'

const theme = useTheme()
const { xs } = useDisplay()
const nuxtApp = useNuxtApp()
const route = useRoute()

const props = defineProps({
    seller: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
    howMany: {
        type: Number,
        default: 5,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `seller-${props.handle}-${props.howMany}-products`,
    () => $fetch(`/api/product/query?id=${props.seller}&what=seller&howMany=${props.howMany}`),
    {
        transform: (data) => {
            let tempProds = data.products.edges
                .map((edge) => edge.node)
                .filter((item) => item.handle !== route.params.slug)
            if (tempProds.length > 4) {
                tempProds.pop()
            }
            return {
                sellerProducts: tempProds, //data.products.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

watchEffect(() => {
    if (error.value) {
        throw createError({
            statusCode: 500,
            message: error.value,
            fatal: false,
        })
    }
})
</script>

<template>
    <v-row id="productsseller" class="justify-center rounded">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="10"><app-loader /></v-col>
        <v-col v-else-if="data.sellerProducts.length > 0" cols="10" sm="10">
            <v-row class="justify-center">
                <v-col cols="12" class="mt-16">
                    <app-section-header
                        :id="`productsseller`"
                        :title="`More by ${seller}`"
                        :subtitle="`Check out these amazing products by ${seller}`"
                    />
                </v-col>

                <v-col v-for="product in data.sellerProducts" :key="product.id" cols="12" sm="6" lg="3">
                    <product-card-seller
                        :product="product"
                        :style="
                            theme.global.name.value == 'sTDarkTheme'
                                ? 'background-color: #161616 !important'
                                : undefined
                        "
                    />
                </v-col>

                <v-col cols="12" class="pt-6 mb-16 d-flex justify-center">
                    <v-theme-provider
                        :theme="theme.global.name.value == 'sTDarkTheme' ? 'sTLightTheme' : 'sTDarkTheme'"
                    >
                        <app-button
                            :to="`/seller/` + props.handle"
                            :btn-text="`View All by ` + seller"
                            :append-icon="`mdi-chevron-right`"
                            :aria-label="`View all products by ${seller}`"
                            :size="xs ? undefined : `x-large`"
                        />
                    </v-theme-provider>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
